import { render } from "./StepOne.vue?vue&type=template&id=65c5e600"
import script from "./StepOne.vue?vue&type=script&lang=js"
export * from "./StepOne.vue?vue&type=script&lang=js"
script.render = render

export default script